var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PButton',{staticClass:"buttonSearch",attrs:{"variant":"circle"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"material-icons"},[_vm._v(" "+_vm._s("search")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }